<template>
  <div>
      <div class="overlay">
          <el-card class="login-card" v-loading="loadingVisible">

              <img class="logo" src="@/assets/logo-valorinutritie.png" alt="Valori Nutriție"/>
              <h1 class="serif">Bine ai revenit</h1>
              <div class="subtitlu">valorinutritie.ro</div>

              <el-form ref="myForm" :model="form" :rules="rules" label-width="100%" label-position="top"  @submit.native.prevent="doLogin()">
                  <el-form-item label="Email" prop="email">
                      <el-input type="email" v-model="form.email" placeholder="Adresa ta de email" prefix-icon="el-icon-user" />
                  </el-form-item>

                  <el-form-item label="Parola"  prop="parola">
                      <el-input type="password" v-model="form.parola" placeholder="Parola" prefix-icon="el-icon-lock" show-password />
                  </el-form-item>

                  <el-form-item class="form-actions">
                      <el-button class="btn-login" type="primary" native-type="submit">Autentificare</el-button>
                  </el-form-item>
              </el-form>

              <p class="register">
                  Nu ai cont?
                  <a href="#/register">Creează unul acum</a>
              </p>

          </el-card>

          <div class="footer-note">valori nutriționale și meniu digital pentru restaurantul tău</div>
      </div>
  </div>
</template>

<script>

import BasePage from '@/pages/BasePage.vue';
import settings from '@/backend/LocalSettings';

export default {
  name: "Login",
  extends: BasePage,
  data: function() {
      return {
          form:{
              email:"",
              parola:""
          },
          rules: {
                email: [
                    { required: true, message: 'Emailul este obligatoriu', trigger: 'blur' }
                ],
                parola: [
                    { required: true, message: 'Parola este obligatorie', trigger: 'blur'},
                ]
            }
      }
  },
  methods:{
    doLogin() {
        this.$refs["myForm"].validate(async (valid) => {
            if (valid) {
                this.loadingVisible = true;
                var response        = await this.post("login/login", this.form);
                this.loadingVisible = false;
                if( response.Error ){
                    this.$message.error(response.MesajEroare);
                } else {
                    //redirect
                    settings.set_token(response.Nume, response.Email, response.Token, response.DefaultLanguage);
                    this.$router.push("/ingrediente");
                }
            } else {
                return false;
            }
        });
    }
  }
}
</script>

<style lang="less" scoped>
@import "@/assets/auth.less";

.register{
    text-align: center;
    font-size: 13px;
    color: #6E7A87;
    margin: 4px 0 0;

    a{
        color: #4EA82A;
        font-weight: 700;
        text-decoration: none;

        &:hover{
            text-decoration: underline;
        }
    }
}
</style>
